export enum Language {
    English = 'en',
    Norwegian = 'nb',
}
